import { render, staticRenderFns } from "./compute-product-details.vue?vue&type=template&id=113669d6&scoped=true"
import script from "./compute-product-details.vue?vue&type=script&lang=js"
export * from "./compute-product-details.vue?vue&type=script&lang=js"
import style0 from "./compute-product-details.vue?vue&type=style&index=0&id=113669d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113669d6",
  null
  
)

export default component.exports